import React from "react";
import { Check } from "lucide-react";

interface SelectableEntityCardProps {
  title: string;
  subtitle: string;
  selected: boolean;
  onClick: () => void;
}

const SelectableEntityCard: React.FC<
  SelectableEntityCardProps
> = ({
  title,
  subtitle,
  selected,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className={`
        flex
        w-full
        items-center
        gap-4
        rounded-[8px]
        border
        p-2
        text-left
        transition-colors
        ${
          selected
            ? "border-[#788AF7] bg-[#EBEEFE]"
            : "border-[#E5E5E5] bg-white"
        }
      `}
    >
      <div
        className="
          flex
          min-w-0
          flex-1
          flex-col
          gap-[2px]
        "
      >
        <p
          className="
            truncate
            text-[14px]
            font-normal
            leading-5
            text-[#0A0A0A]
          "
        >
          {title}
        </p>

        <p
          className="
            truncate
            text-[12px]
            font-normal
            leading-4
            text-[#737373]
          "
        >
          {subtitle}
        </p>
      </div>

      <div
        className={`
          flex
          h-[16px]
          w-[16px]
          shrink-0
          items-center
          justify-center
          rounded-[4px]
          shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]
          border
          ${
            selected
              ? "border-[#3551F3] bg-[#3551F3]"
              : "border-[#E5E5E5] bg-white"
          }
        `}
      >
        {selected && (
          <Check
            size={14}
            strokeWidth={2}
            className="text-[#FAFAFA]"
          />
        )}
      </div>
    </button>
  );
};

export default SelectableEntityCard;